import Chart from "chart.js/auto";
import { chartTicks, CHART_TOOLTIP, CHART_LEGEND_LABEL, CHART_GRID, reloadChart } from "../../vendors/chart";
import { COLORS } from "../../utils";

const CHART_WRAPPER = document.getElementById("chart-bar");
let barChart;

export const bar = () => {
	// Chart data
	const DATA = {
		labels: ["Van", "LGV", "Car", "Plant", "HGV", "Specialised", "Motorcycle"],
		datasets: [
			{
				label: "Current Quarter",
				data: [48, 35, 41, 27, 15, 22, 8],
				barThickness: 8,
				backgroundColor: "#8d95ca",
				hoverBackgroundColor: "#8d95ca"
			},
			{
				label: "Previous Quarter",
				data: [53, 32, 33, 22, 18, 26, 10],
				barThickness: 8,
				backgroundColor: "#101B4B",
				hoverBackgroundColor: "#101B4B",
			},
		],
	};

	// Chart config
	const CONFIG = {
		type: "bar",
		data: DATA,
		options: {
			maintainAspectRatio: false,
			layout: {
				padding: {
					left: -8,
					right: 15,
				},
			},
			elements: {
				bar: {
					borderWidth: 0,
				},
			},
			responsive: true,
			plugins: {
				legend: {
					position: "bottom",
					labels: {
						usePointStyle: true,
						...CHART_LEGEND_LABEL,
					},
				},
				title: {
					display: false,
				},
				tooltip: {
					...CHART_TOOLTIP,
					callbacks: {
						label: function(context) {
							const label = context.dataset.label || '';
							const value = context.raw || 0;
							return `${label}: ${value} claims`;
						}
					}
				},
			},
			scales: {
				x: {
					border: {
						display: false,
					},
					grid: {
						display: false,
						drawBorder: false,
						drawOnChartArea: false,
						drawTicks: false,
					},
					ticks: {
						...chartTicks(),
					},
				},
				y: {
					border: {
						display: false,
					},
					grid: {
						...CHART_GRID,
					},
					ticks: {
						maxTicksLimit: 7,
						...chartTicks(),
					},
					title: {
						display: false,
						text: 'Number of Claims',
						color: `rgba(255,255,255, 0.7)`,
					}
				},
			},
		},
	};

	// Init chart
	if (CHART_WRAPPER) {
		barChart = new Chart(CHART_WRAPPER, CONFIG);
	}
};

// Update chart
export const barChartUpdate = () => {
	if (CHART_WRAPPER) {
		setTimeout(() => {
			reloadChart(barChart);
		});
	}
};